import { useDispatch } from "react-redux";
import { logout } from "../../../app/store/slices/authSlice";
import { logoutAndReset } from "../../store/actions/authActions";
import useAxiosPrivate from "./useAxiosPrivate";
import moment from "moment";

const LOGOUT = "/auth/logout";

const useLogout = () => {
  const axiosPrivate = useAxiosPrivate();
  const dispatch = useDispatch();

  const signout = async () => {
    const dates = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    const data = { updated_at: dates };
    const response = await axiosPrivate.post(LOGOUT, data, {
      withCredentials: true,
    });
    // console.log({ "response from server token trouvé ": response?.data });
    if (response?.data?.status) {
      dispatch(logout());
      await dispatch(logoutAndReset());

      // redirection
      window.location.replace("/signin");
    }
  };

  return signout;
};

export default useLogout;
